import routes from '@routes/config';

export default [{
    path: routes.userIdentity.index,
    name: routes.userIdentity.index,
    component: () => import(/* webpackChunkName: "UserIdentity" */  '@components/UserIdentity/Index')
}]
            